import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { AuthenticationModule } from '../modules/authentication/authentication.module';
import { UserSelectionMenuComponent } from '../shared/components/user-selection-menu/user-selection-menu.component';
import { SharedModule } from '../shared/shared.module';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { LogoComponent } from './components/logo/logo.component';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { MenuComponent } from './components/menu/menu.component';
import { ProfileSwitchComponent } from './components/profile-switch/profile-switch.component';
import { StatusBarComponent } from './components/status-bar/status-bar.component';
import { UniversalSearchComponent } from './components/universal-search/universal-search.component';
import { UserSwitchComponent } from './components/user-switch/user-switch.component';
import { DigitalSignageTokenService } from '../modules/digital-signage/services/digital-signage-token.service';
import { ApiInterceptor } from './interceptors/api.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { TimeoutInterceptor } from './interceptors/timeout.interceptor';
import { BreadcrumbService } from './services/breadcrumb.service';
import { GeocodeService } from './services/geocode.service';
import { InterventionService } from './services/intervention.service';

@NgModule({
  declarations: [
    MenuComponent,
    LogoComponent,
    UserSwitchComponent,
    StatusBarComponent,
    UniversalSearchComponent,
    BreadcrumbComponent,
    ProfileSwitchComponent,
    MenuItemComponent,
  ],
  imports: [
    AuthenticationModule,
    RouterModule,
    SharedModule,
    NzDropDownModule,
    NzEmptyModule,
    NzSpaceModule,
    NzBreadCrumbModule,
    NzLayoutModule,
    NzTypographyModule,
    NzPopoverModule,
    UserSelectionMenuComponent,
  ],
  exports: [MenuComponent, StatusBarComponent],
  providers: [
    BreadcrumbService,
    NzMessageService,
    InterventionService,
    NzNotificationService,
    GeocodeService,
    { provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useExisting: DigitalSignageTokenService, multi: true },
  ],
})
export class CoreModule {
  // Prevent Core module from being imported more than once!
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
